module.exports = (__parcel__import__("./" + "module.54a8d6d6.js")).then(() => parcelRequire('2vSYt'));